import { Injectable } from "@angular/core";
import { InAppPurchase } from "@ionic-native/in-app-purchase";

export interface IapSubscribeData {
  transactionId: string;
  receipt: string;
  signature: string;
  productType: string;
}

@Injectable()
export class IapProvider {
  constructor(private iap: InAppPurchase) {}

  subscribe(productId: string): Promise<IapSubscribeData> {
    return this.iap.subscribe(productId);
  }

  getProducts(productIdList: string[]): Promise<any> {
    return this.iap.getProducts(productIdList);
  }

  getReceipt(): Promise<string> {
    return this.iap.getReceipt();
  }

  restorePurchases(): Promise<any> {
    return this.iap.restorePurchases();
  }

  consume(
    productType: string,
    receipt: string,
    signature: string
  ): Promise<any> {
    return this.iap.consume(productType, receipt, signature);
  }

  buy(productId: string): Promise<IapSubscribeData> {
    return this.iap.buy(productId);
  }
}



// WEBPACK FOOTER //
// ./src/providers/iap/iap.ts